import { Component, OnInit, Input } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { APIService } from 'src/app/api.service';
import * as XLSX from 'xlsx';

type AOA = any[];

@Component({
  selector: 'app-import-bom',
  templateUrl: './import-bom.component.html',
  styleUrls: ['./import-bom.component.scss']
})
export class ImportBOMComponent implements OnInit {

  @Input() mdlRef: any;

  constructor(private modalService: NgbModal, private apiService: APIService,) { }

  data: any = {};
  productID: number = 0;
  availableBOM: any = [];
  error: any = {
    showError: false,
    removeError: false,
    apiResponse: false
  };
  itemList : any = [];
  storeBatches: any = [{}];
  Stores : any = [];
  HSNList: string = "";
  ItemCategories : any = [];
  units : any = [];
  stockItems: any = [];
  modalReference: any;
  closeResult: any;
  impNotesTitle: string = "Important Notes";
  impNotesShowActBtn: boolean = false;

  ngOnInit(): void {
    this.apiService.getIDB('erp_inv', (invItems: any) => {
      if (invItems && invItems.length > 0) {
        this.stockItems = invItems;
      }
    });

    let erpCfgCookie = this.apiService.getCookie("ERP_Cfg");
    if (erpCfgCookie) {
      let erpCfgData = JSON.parse(erpCfgCookie);
      this.units = erpCfgData[0].Units ? JSON.parse(erpCfgData[0].Units) : [];
    }
  }

  //checkExcelColumnHeader() - Check for Excel page
  checkExcelColumnHeader(columnName: string){
    let columnHeaderArray: Array<any> = ["Item Name", "Qty"];
    if (columnHeaderArray.findIndex((x: any) => x == columnName) > -1) {
        return true;
    }
    else {
        return false;
    }
  }

  // Import File
  fileName: string = 'SheetJS.xlsx';

  onFileChange(evt: any) {
    this.closeImpNotesModal('direct');
    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];
      
      // Check for Header column
      let columnsArray: any = XLSX.utils.sheet_to_json(wb.Sheets[wsname], { header: 1 })[0];
      let isErrorForColumn:boolean = false;
      for (var i = 0; i < columnsArray.length; i++) {
        let isOkay = this.checkExcelColumnHeader(columnsArray[i]);  
          if (isOkay == false) {
              isErrorForColumn = true;
              break;
          }
      }

      if (isErrorForColumn == true) {
        this.apiService.successAlert("It seems that the downloaded import templated has been changed.  Please download it again and try to import the data again.");
        return;
      }

      this.data = <AOA>(XLSX.utils.sheet_to_json(ws));
      this.checkitemValidation(this.data);
      
      if(this.itemList.length > 0){
          this.error.showError = true;
          this.error.removeError = false;
          $('.modal-dialog').attr('style', 'min-width: 50% !important');
          return;
      }
      else{
        this.error.showError = false;
        this.error.removeError = true;
        this.importItems();
      }
    };
    reader.readAsBinaryString(target.files[0]);
  }

  checkitemValidation(items: Array<any>) {
    let erroList = [];

    items.forEach((item: any) => {
      item.errorMsg = '';
      item.name = item["Item Name"] ? item["Item Name"]?.toLowerCase().trim() : '';
      if (item.name == '') {
        item.errorMsg = item.errorMsg + 'Please enter an item name. '
      }
      else {
        const isCheckDup = items.filter((i: any) => i["Item Name"]?.toLowerCase().trim() == item.name);
        if (isCheckDup.length > 1) {
          item.errorMsg = item.errorMsg + 'Duplicate item in uploaded sheet. '
        }

        const itemExists = this.stockItems.find((i: any) => i.ItemName?.toLowerCase().trim() == item.name)
        if (itemExists) {
          if (itemExists.ItemID == this.productID) {
            item.errorMsg = item.errorMsg + 'Item itself cannot be added as BOM item. '
          }
          item.itemID = itemExists.ItemID;
          item.itemName = itemExists.ItemName;
          item.itemCode = itemExists.ItemCode;
          item.unit = itemExists.SKU;
          item.purchRate = itemExists.DefPurchRate;
        }
        else {
          item.errorMsg = item.errorMsg + 'Invalid item. Item: ' + (item["Item Name"] ? item["Item Name"] : '') + ' not found in inventory. '
        }
      }

      if(item["Qty"] == "undefined" || item["Qty"] == null || isNaN(item["Qty"]) == true) {
        item.errorMsg = item.errorMsg + 'Please enter an item quantity. '
      }
      else if(item["Qty"] < 0){
        item.errorMsg = item.errorMsg + 'Please enter a valid quantity. '
      }
      else if(item["Qty"] > 0){
        let selectedUnit = this.units.filter((unit: any) => unit.UNm == item.unit);
        if(selectedUnit.length > 0){
            let precisonNum = selectedUnit[0].Prcsn;
            item.prcsn = selectedUnit[0].Prcsn;
            let initialQtyPrcsn = String(item["Qty"]).split(".");
            if(initialQtyPrcsn.length > 1){
              let selectedPrcn = String(initialQtyPrcsn[1]).length;
              if(precisonNum < selectedPrcn && selectedPrcn > 0){
                item.errorMsg = item.errorMsg + 'Quantity precision do not match with unit precision.'
              }
            }
        }
      }

      if (item.itemID > 0) {
        const isDupBOM = this.availableBOM.filter((i: any) => i.ItemID == item.itemID);
        if (isDupBOM.length > 0) {
          item.errorMsg = item.errorMsg + 'Duplicate BOM item in uploaded sheet. '
        }
      }
    });

    for(let i: number = 0; i < items.length; i++){
      if(items[i].errorMsg != ''){
        erroList.push({
          srNo: Number(items[i].__rowNum__) + 1,
          itemName: items[i]["Item Name"] ? items[i]["Item Name"] : '',
          msg: items[i].errorMsg
        });
      }
    }
    this.itemList = erroList;
  }

  importItems() {
    let items: any = [];
    this.data.forEach((item: any) => {
      if (item.errorMsg == '') {
        items.push({
          ItemID: item.itemID,
          productName: item.itemName,
          productCode: item.itemCode,
          ReqdQty: item.Qty,
          TypeID: 1,
          Unit: item.unit,
          SKUPrecision: item.prcsn,
          purchRate: item.purchRate
        });
      }
    })
    const data: any = {
      action: 'Done',
      data: items
    }
    this.closeModal(data);
  }

  openModal(mdlID: any, from: any) { 
    if (from == 'fromInfo') {
      this.impNotesTitle = "Important Notes";
      this.impNotesShowActBtn = false;

    } else {
      this.impNotesTitle = "Have you ensured the following?";
      this.impNotesShowActBtn = true;
    }
    this.modalReference = this.modalService.open(mdlID, { ariaLabelledBy: 'modal-basic-title', windowClass: 'impNotesMdl', backdrop: 'static', keyboard: false });
      this.modalReference.result.then((result: any) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason: any) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
        return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
        return 'by clicking on a backdrop';
    } else {
        return `with: ${reason}`;
    }
  }

  closeImpNotesModal(action: any) {
    if (action == 'alert') {
      this.apiService.successAlert('Please update the excelsheet and try again.');
    }
    this.modalReference.close();
  }

  closeModal(data: any) {
    this.mdlRef.close(data);
  }

}
